import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Button, Container } from "react-bootstrap";
import classes from "../WebsiteManagement/websiteManagement.module.css";
import Page from "../pagination/pagination";
import {
  GetAdminBusBookings,
  DownloadBookingTicket,
  DownloadBookingInvoice,
} from "../../entities/action/action";

const PAGE_SIZE = 50;

const thStyle = { padding: "10px 6px", textAlign: "left", fontSize: 12, fontWeight: 600, borderBottom: "2px solid #ccc", whiteSpace: "nowrap" };
const tdStyle = { padding: "10px 6px", fontSize: 12, borderBottom: "1px solid #eee", verticalAlign: "top" };

const getBusCustomerName = (item) => {
  const lead = (item.passengers || []).find((p) => p.lead) || item.passengers?.[0];
  if (!lead) return item.name || "-";
  return `${lead.firstName || ""} ${lead.lastName || ""}`.trim() || item.name || "-";
};

const BusBookings = () => {
  const [all, setAll] = useState([]);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    (async () => {
      const res = await GetAdminBusBookings();
      if (res.success && res.bookings) setAll(res.bookings);
    })();
  }, []);

  useEffect(() => { setPage(1); }, [search]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return all;
    return all.filter((b) => {
      const name = (b.name || getBusCustomerName(b)).toLowerCase();
      const phone = String(b.phone || "").toLowerCase();
      return name.includes(q) || phone.includes(q);
    });
  }, [all, search]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const pageItems = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <Fragment>
      <Container style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
        <form onSubmit={(e) => e.preventDefault()} style={{ display: "flex", alignItems: "stretch", width: "50vw" }}>
          <input className={classes.SearchInput} placeholder="Search by Name or Phone Number" value={searchInput}
            onChange={(e) => { setSearchInput(e.target.value); setSearch(e.target.value); }} />
          <button type="button" className={classes.SearchButton} onClick={() => setSearch(searchInput)}>Search</button>
        </form>
      </Container>
      {pageItems.length ? (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1100 }}>
            <thead>
              <tr style={{ backgroundColor: "#585858", color: "#fff" }}>
                <th style={thStyle}>Booking Date & Time</th>
                <th style={thStyle}>Departure City & Boarding Point</th>
                <th style={thStyle}>Arrival City & Drop Off</th>
                <th style={thStyle}>Traveller's Name & Details</th>
                <th style={thStyle}>PNR & Bus Details</th>
                <th style={thStyle}>Seat Details</th>
                <th style={thStyle}>Reference ID</th>
                <th style={thStyle}>Base Amount</th>
                <th style={thStyle}>Purchase Amount</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pageItems.map((item) => {
                const orderDate = new Date(item?.orderDate);
                const customerName = getBusCustomerName(item);
                const seats = (item.passengers || []).filter((p) => p.seatName).map((p) => p.seatName).join(", ");
                return (
                  <tr key={item.bookingId} style={{ backgroundColor: "#f9f9f9" }}>
                    <td style={tdStyle}>
                      {orderDate.getDate()}/{orderDate.getMonth() + 1}/{orderDate.getFullYear()}
                      <div style={{ color: "gray" }}>{orderDate.toLocaleTimeString()}</div>
                    </td>
                    <td style={tdStyle}>
                      {item.sourceCity || "—"}
                      <div style={{ color: "gray" }}>{item.journeyDate || ""}</div>
                      {item.departureTime && <div style={{ color: "gray" }}>{item.departureTime}</div>}
                      {item.boardingPoint && <div style={{ color: "gray" }}>{item.boardingPoint}</div>}
                    </td>
                    <td style={tdStyle}>
                      {item.destinationCity || "—"}
                      {item.arrivalTime && <div style={{ color: "gray" }}>{item.arrivalTime}</div>}
                      {item.droppingPoint && <div style={{ color: "gray" }}>{item.droppingPoint}</div>}
                    </td>
                    <td style={tdStyle}>
                      <div>{item.name || customerName}</div>
                      <div style={{ color: "gray" }}>{item.phone || "—"}</div>
                    </td>
                    <td style={tdStyle}>
                      <div>{item.bookingRef || "—"}</div>
                      <div style={{ color: "gray" }}>{item.operatorName || "Bus"}</div>
                      {item.busType && <div style={{ color: "gray" }}>{item.busType}</div>}
                    </td>
                    <td style={tdStyle}>{seats || "—"}</td>
                    <td style={tdStyle}>{item.bookingRef || "—"}</td>
                    <td style={tdStyle}>INR {Number(item.amount || 0) / 100}</td>
                    <td style={tdStyle}>{item.offeredPrice ? `INR ${Number(item.offeredPrice)}` : "—"}</td>
                    <td style={tdStyle}>
                      <Button size="sm" variant="outline-primary" style={{ fontSize: 10, marginBottom: 5, whiteSpace: "nowrap" }} onClick={() => DownloadBookingTicket(item.bookingId)}>
                        Download Ticket
                      </Button>
                      <Button size="sm" variant="outline-secondary" style={{ fontSize: 10, whiteSpace: "nowrap" }}
                        onClick={() => DownloadBookingInvoice(item.bookingId, `Bus_Invoice_${item.bookingRef || item.bookingId}.pdf`)}>
                        Download Invoice
                      </Button>
                      <div style={{ background: "#0dcaf0", padding: 4, marginTop: 5, textAlign: "center", fontSize: 10 }}>
                        {(item?.status || "").toUpperCase()}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No bus bookings found</p>
      )}
      {totalPages > 1 && <Page count={totalPages} page={page} change={(_, v) => setPage(v)} />}
    </Fragment>
  );
};

export default BusBookings;
